module.exports = __webpack_public_path__ + "static/media/paint.59544d80.svg";